import React from 'react'
import { IconCheck, IconFileUpload, IconX } from '@tabler/icons-react'
import Typography from 'src/components/atoms/Typography'
import { formatFileSize } from 'src/enviroment/lib/formatters/format-file-size'

interface CopaFileRowProps {
  file: File
  onRemove: () => void
  showCheck?: boolean
}

/** A selected-file row shared by the COPA single- and multi-file dropzones. */
const CopaFileRow: React.FC<CopaFileRowProps> = ({ file, onRemove, showCheck = false }) => (
  <div className="flex w-full items-center gap-3 rounded-lg border border-light-green-500 bg-gray-900 p-3">
    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-light-green-500 bg-light-green-500/10">
      <IconFileUpload size={20} className="text-light-green-500" stroke={1.5} />
    </div>

    <div className="flex min-w-0 flex-1 flex-col">
      <div className="flex items-center gap-1.5">
        <Typography variant="sm" className="truncate text-white">
          {file.name}
        </Typography>
        {showCheck && <IconCheck className="h-4 w-4 shrink-0 text-light-green-500" stroke={1.5} />}
      </div>
      <Typography variant="xs" className="text-gray-400">
        {formatFileSize(file.size)}
      </Typography>
    </div>

    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation()
        onRemove()
      }}
      className="flex shrink-0 items-center gap-1 text-light-green-500 hover:text-light-green-500/80"
    >
      <Typography variant="xs">Remove</Typography>
      <IconX size={16} stroke={1.5} />
    </button>
  </div>
)

export default CopaFileRow
